enum MachineUse {
  clinical = 1,
  nonClinical = 2
}

export default MachineUse;
